import {
  quickbooksTabs,
  tableRowsPerPage,
} from '../../dashboard/components/Quickbooks/constants';
import { QuickbooksStateTypes } from '../../dashboard/components/Quickbooks/types';

const quickbooksState: QuickbooksStateTypes = {
  activeTab: quickbooksTabs.CUSTOM_FIELDS,
  beginOAuthUrl: '',
  formInitialDataValid: true,
  hasEditPermission: false,
  isLoading: false,
  isRevoking: false,
  isRefreshing: false,
  purgeCacheUrl: '',
  quickbooksOnlineIntegrated: false,
  qboCompanyName: '',
  quickbooksOnlineCustomers: {
    customers: [],
    customerChoices: [],
    initialCustomers: [],
    isSavingCustomerMappings: false,
    loading: false,
  },
  quickbooksOnlineProducts: {
    products: [],
    productChoices: [],
    initialProducts: [],
    isSavingProductMappings: false,
    loading: false,
  },
  revokeUrl: '',
  salesformCustomFields: {
    customFields: [],
    customFieldChoices: [],
    initialCustomFields: [],
    isSavingCustomFields: false,
    loading: false,
  },
  tableRowsPerPage: {
    rowsPerPage: tableRowsPerPage.DEFAULT_ROWS_PER_PAGE,
    rowsPerPageOptions: [...tableRowsPerPage.ROWS_PER_PAGE_OPTIONS],
  },
  vendorId: null,
};

export default quickbooksState;
